import React from "react";
import { Quote } from "lucide-react";
import { STORY } from "../mock";

export default function Story() {
  return (
    <section id="story" className="py-24 md:py-32 grain-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image + quote */}
          <div className="reveal relative order-2 lg:order-1">
            <div className="rounded-[26px] overflow-hidden ticket-edge bg-[#FBF6EA] p-2.5 shadow-[0_30px_60px_-30px_rgba(60,40,20,0.5)]">
              <div className="overflow-hidden rounded-[18px]">
                <img
                  src={STORY.img}
                  alt="Uncle Willie welcoming guests"
                  className="img-zoom w-full h-[380px] md:h-[520px] object-cover"
                />
              </div>
              <p className="label-mono text-[#8A7C68] text-center pt-3 pb-1">
                Uncle Willie welcomes you
              </p>
            </div>

            <div className="absolute -bottom-8 right-2 md:-right-6 max-w-xs bg-[#D5521B] text-[#F3EAD7] rounded-2xl p-5 shadow-2xl rotate-[-2deg]">
              <Quote size={22} className="text-[#F0C766] mb-2" />
              <p className="font-display italic text-lg leading-snug">
                “{STORY.quote}”
              </p>
              <p className="label-mono text-[#F0C766] mt-3">{STORY.quoteBy}</p>
            </div>
          </div>

          {/* Text */}
          <div className="reveal order-1 lg:order-2">
            <span className="label-mono text-[#D5521B]">{STORY.eyebrow}</span>
            <h2 className="font-display font-black text-4xl md:text-6xl text-[#16110E] mt-4 leading-[0.98]">
              {STORY.title}
            </h2>
            <div className="mt-6 space-y-4 text-[#5E5548] leading-relaxed">
              {STORY.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div className="mt-8 grid grid-cols-3 gap-4 border-t border-[#DCCFB4] pt-6">
              {STORY.stats.map((s) => (
                <div key={s.k}>
                  <p className="label-mono text-[#8A7C68]">{s.k}</p>
                  <p className="font-display text-xl font-bold text-[#16110E] mt-1">
                    {s.v}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
